import firebase from 'firebase'

var firebaseConfig = {
    apiKey: "AIzaSyA_1ziA1KZtukweXE33lKhI08hiK3UVyG4",
    authDomain: "kindred-85598.firebaseapp.com",
    databaseURL: "https://kindred-85598.firebaseio.com",
    projectId: "kindred-85598",
    storageBucket: "kindred-85598.appspot.com",
};

firebase.initializeApp(firebaseConfig);
export default firebase;